import getConfiguration, { EnvironmentConfiguration } from '@/shared/configuration';
import logger from '@/shared/logger';

const environmentConfiguration: EnvironmentConfiguration = getConfiguration();
/**
 * @param merchantId contentful entry identifier, the first entry tied to this merchant will be returned
 */
async function fetchContentfulEntry(merchantId) {
  const contentfulSpaceId = environmentConfiguration.contentfulSpaceId;
  const contentfulAccessToken = environmentConfiguration.contentfulAccessToken;
  const url = `https://cdn.contentful.com/spaces/${contentfulSpaceId}/environments/master/entries?access_token=${contentfulAccessToken}&content_type=checkoutPromotions&fields.merchantId=${merchantId}`;
  try {
    const response = await fetch(url);
    const body = await response.json();
    return body.items[0].fields;
  } catch (e) {
    logger.info(e);
  }
};

const promotions = {
  fetchContentfulEntry,
};
export default promotions;